import { render, staticRenderFns } from "./ResultStatistics.vue?vue&type=template&id=0a328c0d&scoped=true"
import script from "./ResultStatistics.vue?vue&type=script&lang=js"
export * from "./ResultStatistics.vue?vue&type=script&lang=js"
import style0 from "./ResultStatistics.vue?vue&type=style&index=0&id=0a328c0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a328c0d",
  null
  
)

export default component.exports